import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/content';

// DESIGN PREVIEW ONLY: synthetic samples, not photos supplied by reviewers.
// Replace these assets with consented customer photos before publishing.
const samplePhotos: Record<number, {
  image: string;
  alt: string;
}> = {
  0: {
    image: 'https://cdn.magicpatterns.com/uploads/kCnKV3byihaXUyvYqp3Bey/review-new-01.png',
    alt: 'AI-generated design sample: a boy at a dining table taping coloured straws inside a cardboard box lid to build a marble maze, with the four illustrated steps open on a tablet beside him'
  },
  3: {
    image: 'https://cdn.magicpatterns.com/uploads/dRN1Z5sG6fdrKvAXTwnJhS/review-new-02.png',
    alt: 'AI-generated design sample: a girl sitting on a living-room rug pushing a cardboard car with blue bottle-cap wheels, with the build steps open on a tablet behind her'
  },
  4: {
    image: 'https://cdn.magicpatterns.com/uploads/8YiQwshBaYAbHe1eHgPK65/review-new-03.png',
    alt: 'AI-generated design sample: a girl showing her grandmother a pencil organizer she made from cardboard tubes decorated with stars, with the project page open on a tablet on the kitchen table'
  }
};
function Stars({
  rating
}: {
  rating: number;
}) {
  return <div className="flex items-center gap-0.5" aria-label={`${rating} out of 5 stars`} data-id="element-186" data-mp="2hgax4l28ugu6">
      {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className={`h-3.5 w-3.5 ${star <= rating ? 'fill-gold-400 text-gold-400' : 'text-cream-300'}`} aria-hidden="true" data-id="element-187" data-mp="3a2vqfr2a530d" />)}
    </div>;
}
export function Reviews() {
  return <section className="mx-auto max-w-[980px] px-5 pb-14 pt-8 sm:px-6 md:px-8" data-id="element-188" data-mp="30dc42bfcyr0r">
      <div className="text-center" data-id="element-189" data-mp="30b94p0sbfljd">
        <p className="font-display text-[44px] font-semibold leading-none tracking-[-0.02em] text-ink-900" data-id="element-190" data-mp="2wca5lwt9mizu">
          4.8
        </p>
        <div className="mt-3 flex justify-center" data-id="element-191" data-mp="3sug29he70wr3">
          <Stars rating={5} data-id="element-192" data-mp="3o36i2wbeylml" />
        </div>
        <p className="mt-3 whitespace-nowrap text-[13.5px] text-ink-500" data-id="element-193" data-mp="3o24vbul1cap1">
          Based on reviews from parents across the world
        </p>
      </div>

      <ul className="mt-9 grid gap-3 md:grid-cols-2 md:gap-4" data-id="element-194" data-mp="1r47kgv5h8egq">
        {reviews.map((review, index) => <li key={review.name} className="rounded-2xl border border-cream-300 bg-white p-5" data-id="element-195" data-mp="1cfkwy65p4gef" data-mpi={index}>
            <div className="flex items-center gap-3" data-id="element-196" data-mp="1heny3fik22h4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cream-200 font-display text-[15px] font-semibold text-ink-800" aria-hidden="true" data-id="element-197" data-mp="1hd34pt7z8pku">
                {review.name.charAt(0)}
              </span>
              <p className="flex-1 font-display text-[16px] font-semibold leading-tight text-ink-900" data-id="element-198" data-mp="tgqf2oaxqzu1">
                {review.name}
              </p>
              <Stars rating={review.rating} data-id="element-199" data-mp="ygl6qu2jbtg5" />
            </div>
            <p className="mt-3.5 text-[15.5px] leading-[1.65] text-ink-800" data-id="element-200" data-mp="2nuzrz4ecgy6w">{review.text}</p>
            {samplePhotos[index] && <figure className="mt-4 max-w-[300px] overflow-hidden rounded-xl border border-cream-300" data-id="element-201" data-mp="2su2x0oubr4ev">
                <img src={samplePhotos[index].image} alt={samplePhotos[index].alt} width={1448} height={1086} loading="lazy" decoding="async" className="block h-auto w-full" data-id="element-202" data-mp="h7iuqpbv6pyz" />
                
              </figure>}
          </li>)}
      </ul>
    </section>;
}